<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title>{{$t('admissions.entries.page_title')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-layout row wrap justify-end align-end>
              <v-btn color="primary" @click="showAssigned">Asignados</v-btn>
              <v-btn color="primary" @click="showNotAssigned">No asignados</v-btn>
            </v-layout>
        </v-toolbar>
        <v-dialog
          v-model="dialogReport"
          scrollable fullscreen
          transition="dialog-transition">
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialogReport = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Reporte General Familia {{ report.last_name }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text>
                <v-layout row>
                  <v-flex xs9 px-1>
                    <h2 class="font-weight-regular">Información del aspirante</h2>
                    <v-layout row>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.vinculada') }}</h3>
                        {{ report.vinculada }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.first_name') }}</h3>
                        {{ report.first_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.last_name') }}</h3>
                        {{ report.last_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.date_of_birth') }}</h3>
                        {{ report.date_of_birth }}
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.place_of_birth') }}</h3>
                        {{ report.place_of_birth }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.doc_type') }}</h3>
                        {{ report.document_type }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.nuip') }}</h3>
                        {{ report.nuip }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.rc') }}</h3>
                        <a v-if="report.rc" :href="report.rc" target="_blank">Descargar</a>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs3 px-1>
                        <h3>Foto</h3>
                        <a v-if="report.photo" :href="report.photo" target="_blank">Descargar</a>
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.twin') }}</h3>
                        {{ report.twin }}
                      </v-flex>
                    </v-layout>
                    <v-layout row v-if="report.twin == 'Si'">
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.twin_first_name') }}</h3>
                        {{ report.twin_first_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.twin_last_name') }}</h3>
                        {{ report.twin_last_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.twin_nuip') }}</h3>
                        {{ report.twin_nuip }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.twin_gender') }}</h3>
                        {{ report.twin_gender }}
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.gender') }}</h3>
                        {{ report.gender }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.home_address') }}</h3>
                        {{ report.address }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.religion') }}</h3>
                        {{ report.religion }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.nationality') }}</h3>
                        {{ report.nationality }}
                      </v-flex>
                    </v-layout>

                    <hr class="my-3">
                    <h2 class="font-weight-regular">Información del Acudiente 1</h2>

                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_first_name') }}</h3>
                        {{ report.guardian1_first_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_last_name') }}</h3>
                        {{ report.guardian1_last_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_relation') }}</h3>
                        {{ report.guardian1_relation }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.doc_type') }}</h3>
                        {{ report.guardian1_document_type }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_id') }}</h3>
                        {{ report.guardian1_id }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.expedition_date') }}</h3>
                        {{ report.guardian1_expedition_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.date_birth') }}</h3>
                        {{ report.guardian1_birth_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.country') }}</h3>
                        {{ countryName(report.guardian1_country_birth) }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.state') }}</h3>
                        {{ stateName(report.guardian1_state_birth, report.guardian1_country_birth) }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.city') }}</h3>
                        {{ cityName(report.guardian1_city_birth, report.guardian1_state_birth) }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_email') }}</h3>
                        {{ report.guardian1_email }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_cellphone') }}</h3>
                        {{ report.guardian1_cellphone }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.gender') }}</h3>
                        {{ report.guardian1_gender }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.home_address') }}</h3>
                        {{ report.guardian1_address }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.religion') }}</h3>
                        {{ report.guardian1_religion }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.nationality') }}</h3>
                        {{ report.guardian1_nationality }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>Foto</h3>
                        <a v-if="report.guardian1_photo" :href="report.guardian1_photo" target="_blank">Descargar</a>
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.document') }}</h3>
                        <a v-if="report.guardian1_document" :href="report.guardian1_document" target="_blank">Descargar</a>
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.work_letter') }}</h3>
                        <a v-if="report.guardian1_employment_letter" :href="report.guardian1_employment_letter" target="_blank">Descargar</a>
                      </v-flex>
                    </v-layout>
                    <h2 class="text-xs-center my-3">{{ $t('admissions.titles.professional_info') }}</h2>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_profession') }}</h3>
                        {{ report.guardian1_profession }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.employee') }}</h3>
                        {{ report.guardian1_employed }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.independent') }}</h3>
                        {{ report.guardian1_independent }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.ocupation') }}</h3>
                        {{ report.guardian1_ocupation }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.position') }}</h3>
                        {{ report.guardian1_position }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.company_time') }}</h3>
                        {{ report.guardian1_time }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.company') }}</h3>
                        {{ report.guardian1_company }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.company_contact') }}</h3>
                        {{ report.guardian1_company_contact }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.phone_number') }}</h3>
                        {{ report.guardian1_company_number }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>Email</h3>
                        {{ report.guardian1_company_email }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.website') }}</h3>
                        {{ report.guardian1_company_web }}
                      </v-flex>
                    </v-layout>
                    <h2 class="text-xs-center my-3">{{ $t('admissions.titles.academic_info') }}</h2>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_graduate') }}</h3>
                        {{ report.guardian1_graduate }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_date') }}</h3>
                        {{ report.guardian1_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.secondary_school') }}</h3>
                        {{ report.guardian1_school }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_date') }}</h3>
                        {{ report.guardian1_school_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.university') }}</h3>
                        {{ report.guardian1_college }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian1_date') }}</h3>
                        {{ report.guardian1_college_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.university_degree') }}</h3>
                        {{ report.guardian1_title }}
                      </v-flex>
                    </v-layout>

                    <hr class="my-3">
                    <h2 class="font-weight-regular">Información del Acudiente 2</h2>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_first_name') }}</h3>
                        {{ report.guardian2_first_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_last_name') }}</h3>
                        {{ report.guardian2_last_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_relation') }}</h3>
                        {{ report.guardian2_relation }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.doc_type') }}</h3>
                        {{ report.guardian2_document_type }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_id') }}</h3>
                        {{ report.guardian2_id }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.expedition_date') }}</h3>
                        {{ report.guardian2_expedition_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.date_birth') }}</h3>
                        {{ report.guardian2_birth_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.country') }}</h3>
                        {{ countryName(report.guardian2_country_birth) }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.state') }}</h3>
                        {{ stateName(report.guardian2_state_birth, report.guardian2_country_birth) }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.city') }}</h3>
                        {{ cityName(report.guardian2_city_birth, report.guardian2_state_birth) }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_email') }}</h3>
                        {{ report.guardian2_email }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_cellphone') }}</h3>
                        {{ report.guardian2_cellphone }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.gender') }}</h3>
                        {{ report.guardian2_gender }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.home_address') }}</h3>
                        {{ report.guardian2_address }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.religion') }}</h3>
                        {{ report.guardian2_religion }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.nationality') }}</h3>
                        {{ report.guardian2_nationality }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>Foto</h3>
                        <a v-if="report.guardian2_photo" :href="report.guardian2_photo" target="_blank">Descargar</a>
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.document') }}</h3>
                        <a v-if="report.guardian2_document" :href="report.guardian2_document" target="_blank">Descargar</a>
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.work_letter') }}</h3>
                        <a v-if="report.guardian2_employment_letter" :href="report.guardian2_employment_letter" target="_blank">Descargar</a>
                      </v-flex>
                    </v-layout>
                    <h2 class="text-xs-center my-3">{{ $t('admissions.titles.professional_info') }}</h2>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_profession') }}</h3>
                        {{ report.guardian2_profession }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.employee') }}</h3>
                        {{ report.guardian2_employed }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.independent') }}</h3>
                        {{ report.guardian2_independent }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.ocupation') }}</h3>
                        {{ report.guardian2_ocupation }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.position') }}</h3>
                        {{ report.guardian2_position }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.company_time') }}</h3>
                        {{ report.guardian2_time }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.company') }}</h3>
                        {{ report.guardian2_company }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.company_contact') }}</h3>
                        {{ report.guardian2_company_contact }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.phone_number') }}</h3>
                        {{ report.guardian2_company_number }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>Email</h3>
                        {{ report.guardian2_company_email }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.website') }}</h3>
                        {{ report.guardian2_company_web }}
                      </v-flex>
                    </v-layout>
                    <h2 class="text-xs-center my-3">{{ $t('admissions.titles.academic_info') }}</h2>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_graduate') }}</h3>
                        {{ report.guardian2_graduate }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_date') }}</h3>
                        {{ report.guardian2_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.secondary_school') }}</h3>
                        {{ report.guardian2_school }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_date') }}</h3>
                        {{ report.guardian2_school_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.university') }}</h3>
                        {{ report.guardian2_college }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.guardian2_date') }}</h3>
                        {{ report.guardian2_college_date }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.university_degree') }}</h3>
                        {{ report.guardian2_title }}
                      </v-flex>
                    </v-layout>

                    <hr class="my-3">
                    <h2 class="font-weight-regular">{{ $t(`admissions.form.payment_responsible`) }}</h2>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.payment_responsible') }}</h3>
                        {{ report.payment_responsible }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.doc_type') }}</h3>
                        {{ report.other_document_type }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.id') }}</h3>
                        {{ report.other_id }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.date_birth') }}</h3>
                        {{ report.other_birth_date }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.other_first_name') }}</h3>
                        {{ report.other_first_name }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.other_last_name') }}</h3>
                        {{ report.other_last_name }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.other_cellphone') }}</h3>
                        {{ report.other_cellphone }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.other_email') }}</h3>
                        {{ report.other_email }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('register_form.country') }}</h3>
                        {{ countryName(report.other_country) }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('register_form.state') }}</h3>
                        {{ stateName(report.other_state, report.other_country) }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('register_form.city') }}</h3>
                        {{ cityName(report.other_city, report.other_state) }}
                      </v-flex>
                      <v-flex xs3 px-1 v-if="report.payment_responsible === 'Otro'">
                        <h3>{{ $t('admissions.form.other_address') }}</h3>
                        {{ report.other_address }}
                      </v-flex>
                    </v-layout>

                    <hr class="my-3">
                    <h2 class="font-weight-regular">{{ $t(`admissions.titles.additional_info`) }}</h2>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.first_language') }}</h3>
                        {{ report.first_language }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.wait_list') }}</h3>
                        {{ report.wait_list }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.wait_list_name') }}</h3>
                        {{ report.wait_list_name }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.previous_process') }}</h3>
                        {{ report.previous_process }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.tcs_description') }}</h3>
                        {{ report.tcs_description }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.question') }}</h3>
                        {{ report.question }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.entries.form.meeting') }}</h3>
                        <span v-if="report.meeting" class="text-xs-center">{{ report.meeting.description }}</span>
                      </v-flex>
                      <v-flex xs12 px-1>
                        <h3>{{ $t('admissions.form.notes') }}</h3>
                        {{ report.notes }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.family_tcs') }}</h3>
                        {{ report.family_tcs }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="report.family_tcs === 'Si'">
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.full_name') }}</h3>
                        {{ report.family_tcs_name1 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.relation') }}</h3>
                        {{ report.family_tcs_relation1 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.grade') }}</h3>
                        {{ report.family_tcs_grade1 }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="report.family_tcs === 'Si'">
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.full_name') }}</h3>
                        {{ report.family_tcs_name2 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.relation') }}</h3>
                        {{ report.family_tcs_relation2 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.grade') }}</h3>
                        {{ report.family_tcs_grade2 }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.siblings_not_tcs') }}</h3>
                        {{ report.other_schools }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="report.other_schools === 'Si'">
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.full_name') }}</h3>
                        {{ report.other_school_name1 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.grade') }}</h3>
                        {{ report.other_school_grade1 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.school') }}</h3>
                        {{ report.other_school_school1 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.city') }}</h3>
                        {{ report.other_school_city1 }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="report.other_schools === 'Si'">
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.full_name') }}</h3>
                        {{ report.other_school_name2 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.grade') }}</h3>
                        {{ report.other_school_grade2 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('admissions.form.school') }}</h3>
                        {{ report.other_school_school2 }}
                      </v-flex>
                      <v-flex xs3 px-1>
                        <h3>{{ $t('register_form.city') }}</h3>
                        {{ report.other_school_city2 }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 px-1>
                        <h3>{{ $t('admissions.form.important_factor') }}</h3>
                        {{ report.why_tcs }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs3 px-1 text-xs-center>
                    <div v-if="report.family_id" class="sticky">
                      <v-btn
                        @click="getBitacora(report.family_id)"
                        color="primary">
                        Bitácora
                      </v-btn>
                      <br><br>
                      <v-btn
                        @click="getReferences(report.family_id)"
                        color="primary">
                        Referencias
                      </v-btn>
                      <br><br>
                      <v-btn
                        @click="getRecommendations(report.family_id)"
                        color="primary">
                        Recomendaciones
                      </v-btn>
                      <br><br>
                      <v-btn
                        @click="getScore(report.id)"
                        color="primary">
                        Calificación
                      </v-btn>
                      <br><br>
                      <v-btn
                        @click="counsel_dialog = true"
                        color="primary">
                        Consejería
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
        </v-dialog>
        <v-data-table
            :headers="headers"
            :items="entries_to_show"
            :loading="loadingTable"
            class="elevation-1"
            :pagination.sync="pagination"
        >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">
                  <v-btn
                    @click="seeReport(props.item.id)"
                    color="primary">
                    Reporte
                  </v-btn>
                </td>
                <td class="text-xs-center">{{ props.item.full_name }}</td>
                <td class="text-xs-center">{{ props.item.family.employee == 1 ? 'Si' : 'No' }}</td>
                <td class="text-xs-center">{{ props.item.vinculada }}</td>
                <td class="text-xs-center">{{ props.item.guardian1_first_name + ' ' + props.item.guardian1_last_name }}</td>
                <td class="text-xs-center">{{ props.item.guardian2_first_name + ' ' + props.item.guardian2_last_name }}</td>
                <td class="text-xs-center">{{ props.item.average.admissions }}</td>
                <td class="text-xs-center">{{ props.item.average.counsel }}</td>
                <td class="text-xs-center">{{ props.item.average.rectory }}</td>
                <td class="text-xs-center">{{ props.item.average.total }}</td>
                <td class="text-xs-center">
                  <v-checkbox
                    :key="props.item.id"
                    :name="`check_${props.item.id}`"
                    :input-value="props.item.rectory_status"
                    @change="handleRectoryStatus(props.item.rectory_id, props.item.rectory_status)"
                    color="primary"
                    class="center"
                  ></v-checkbox>
                </td>
                <td class="text-xs-center">
                  <v-textarea
                    rows="2"
                    :key="props.item.id"
                    :name="`text_${props.item.id}`"
                    v-model="props.item.rectory_notes"
                    color="primary"
                    class="center"
                  ></v-textarea>
                </td>
            </template>
        </v-data-table>
      <v-dialog
        v-model="bitacora_dialog"
        transition="dialog-transition"
        max-width="1280px"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="bitacora_dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Bitácora</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <bitacora
            :bitacora="bitacora"
            v-on:fetchBitacora="fetchBitacora"
            :family_id="family_id"
          >
          </bitacora>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="rec_dialog"
        transition="dialog-transition"
        max-width="1280px"
        overlay-color="white"
      >
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="rec_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Recomendaciones</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <recommendations
          :recommendations="recommendations"
          :family_id="family_id"
        ></recommendations>
      </v-dialog>
      <v-dialog
        v-model="ref_dialog"
        transition="dialog-transition"
        max-width="1280px"
        overlay-color="white"
      >
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="ref_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Referencias</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <references
          :references="references"
          :family_id="family_id"
        ></references>
      </v-dialog>
      <v-dialog v-if="score"
        v-model="score_dialog"
        transition="score-transition"
        max-width="1280px"
        overlay-color="white"
      >
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="score_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Puntuación</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <score
          :score="score"
          :settings="settings"
          evaluator="rectory"
          v-on:fetchEntries="getEntry"
        ></score>
      </v-dialog>
      <v-dialog v-if="report.family_id"
        v-model="counsel_dialog"
        transition="score-transition"
        max-width="1280px"
        overlay-color="white"
      >
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="counsel_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Reporte Consejería</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          </v-toolbar-items>
        </v-toolbar>
        <counsel
          :family="report"
        ></counsel>
      </v-dialog>
      <v-dialog
        v-model="assigned_dialog"
        transition="dialog-transition"
        max-width="600px"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="assigned_dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Enviar notificación a familias con cupo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
            <v-card-text>
              <ul>
                <li v-for="(item, index) in assigned" :key="index">{{ item.last_name }}</li>
              </ul>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="sendAssigned">Enviar</v-btn>
                <v-btn color="error" @click="assigned_dialog = false">{{$t('admissions.entries.form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="not_assigned_dialog"
        transition="dialog-transition"
        max-width="600px"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="not_assigned_dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Enviar notificación a familias sin cupo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
            <v-card-text>
              <ul>
                <li v-for="(item, index) in not_assigned" :key="index">{{ item.last_name }}</li>
              </ul>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="sendNotAssigned">Enviar</v-btn>
                <v-btn color="error" @click="not_assigned_dialog = false">{{$t('admissions.entries.form.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform';
import bitacora from './bitacora'
import recommendations from './recommendations'
import references from './references'
import score from './score'
import counsel from './counsel_report'
export default {
  name: 'admission-entries',
  components: {
    'bitacora': bitacora,
    'recommendations': recommendations,
    'references': references,
    'score': score,
    'counsel': counsel,
  },
  data() {
    return {
      headers: [
        { text: 'Reporte', align: 'center', value: '', sortable: false },
        { text: this.$t('admissions.council_form.prospect'), align: 'center', value: 'full_name' },
        { text: 'Staff', align: 'center', value: 'family.employee' },
        { text: 'Vinculada', align: 'center', value: 'vinculada' },
        { text: this.$t('admissions.council_form.guardian_1'), align: 'center', value: 'guardian1_first_name' },
        { text: this.$t('admissions.council_form.guardian_2'), align: 'center', value: 'guardian2_first_name' },
        { text: 'Admisiones', align: 'center', value: 'average.admissions' },
        { text: 'Consejería', align: 'center', value: 'average.counsel' },
        { text: 'Rectoría', align: 'center', value: 'average.rectory' },
        { text: 'Promedio', align: 'center', value: 'average.total' },
        { text: 'Continua', align: 'center', value: 'rectory_status' },
        { text: 'Observaciones', align: 'center', value: 'rectory_notes', width: '200px' }
      ],
      entry: [],
      entries_to_show: [],
      typesItems: [],
      editedIndex: -1,
      isLoading: false,
      loadingTable: false,
      dialog: false,
      dialogReport: false,
      disabled_date : false,
      bitacora_dialog : false,
      rec_dialog : false,
      ref_dialog : false,
      score_dialog : false,
      counsel_dialog : false,
      assigned_dialog : false,
      not_assigned_dialog : false,
      bitacora : [],
      recommendations : [],
      references : [],
      score : null,
      settings : null,
      family_id : '',
      entry_id : 0,
      family_name : '',
      countries: [],
      states: [],
      cities: [],
      egresado: false,
      guardian1_graduate: 'No',
      guardian2_graduate: 'No',
      pagination: {
        rowsPerPage: -1
      },
      form: new Form({
        vinculada: 'No',
        first_name: '',
        last_name: '',
        nuip: '',
        original_nuip: '',
        date_of_birth: '',
        twin: 'No',
        twin_first_name: '',
        twin_last_name: '',
        twin_nuip: '',
        twin_gender: '',
        gender: '',
        guardian1_first_name: '',
        guardian1_last_name: '',
        guardian1_id: '',
        guardian1_cellphone: '',
        guardian1_email: '',
        guardian1_relation: '',
        guardian1_profession: '',
        guardian1_ocupation: '',
        guardian1_company: '',
        guardian1_graduate: 'No',
        guardian1_date: '',
        guardian2_first_name: '',
        guardian2_last_name: '',
        guardian2_id: '',
        guardian2_cellphone: '',
        guardian2_email: '',
        guardian2_relation: '',
        guardian2_profession: '',
        guardian2_ocupation: '',
        guardian2_company: '',
        guardian2_graduate: 'No',
        guardian2_date: '',
        first_language: '',
        wait_list: 'No',
        wait_list_name: '',
        previous_process: 'No',
        tcs_description: '',
        question: '',
        meeting_id: '',
        notes: '',
      }),
      showSucessMessage: false,
      editingEntry: false,
      userNameMaxLength: 60,
      entries: [],
      cohort_filter: '',
      meeting_filter: '',
      vinculada_filter: '',
      staff_filter: '',
      graduate_filter: '',
      twin_filter: '',
      cohort_options: [],
      meeting_options: [],
      general_options: [
        { value: 'Si', text: 'Si' },
        { value: 'No', text: 'No' },
      ],
      staff_options: [
        { value: 1, text: 'Si' },
        { value: 0, text: 'No' },
      ],
      report: {},
      assigned: [],
      not_assigned: []
    }
  },
  computed: {
    entryResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogReport(val) {
      val || this.close()
    },
    guardian1_graduate(newValue) {
      this.form.guardian1_graduate = newValue
      this.egresado = newValue == 'Si' || this.form.guardian2_graduate == 'Si' ? true : false
    },
    guardian2_graduate(newValue) {
      this.form.guardian2_graduate = newValue
      this.egresado = newValue == 'Si' || this.form.guardian1_graduate == 'Si' ? true : false
    }
  },
  created() {
    this.getEntry()
  },
  methods: {
    async getEntry() {
      this.loadingTable = true;
          
      axios.get('/api/admissions/get_settings')
        .then(resp => {
          if (resp.status === 200) {
            this.settings = resp.data[0]
          }
        })
        .catch(error => console.log(error))

      let { data } = await axios.get('/api/admissions/entries_rectory')
      this.entry = data;
      this.entries_to_show = data;
      this.loadingTable = false;
      
      /*const settings = await axios.get('/api/admissions/settings')
      settings.data.forEach(setting => {
        this.cohort_options.push(
          {
            value: setting.id,
            text: setting.description
          }
        )
      })*/
      
      /*const meetings = await axios.get('/api/admissions/meetings')
      meetings.data.forEach(meeting => {
        this.meeting_options.push(
          {
            value: meeting.id,
            text: meeting.description
          }
        )
      })*/
      axios.get('/api/countries')
        .then(resp => {
          if (resp.status === 200) {
            this.countries = resp.data.countries
          }
        })
        .catch(error => console.log(error))

      axios.get('/api/states')
        .then(resp => {
          if (resp.status === 200) {
            this.states = resp.data.states
          }
        })
        .catch(error => console.log(error))

      axios.get('/api/cities')
        .then(resp => {
          if (resp.status === 200) {
            this.cities = resp.data.cities
          }
        })
        .catch(error => console.log(error))
    },
    close() {
      this.dialog = false
      this.editingEntry = false
      this.entries = []
    },
    seeReport(id_entry) {
      const EntryToEdit = this.entry.filter(type => type.id === id_entry)[0];
      this.dialogReport = true;
      this.report = EntryToEdit;

    },
    getBitacora(family_id) {
      this.family_id = family_id
      axios.get(`/api/admissions/bitacora/${family_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.bitacora = resp.data
            this.bitacora_dialog = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchBitacora() {
      this.getBitacora(this.family_id)
    },
    getRecommendations(family_id) {
      this.family_id = family_id
      axios.get(`/api/admissions/recommendations_family/${family_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.recommendations = resp.data
            this.rec_dialog = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getReferences(family_id) {
      this.family_id = family_id
      axios.get(`/api/admissions/references/${family_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.references = resp.data
            this.ref_dialog = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getScore(entry_id) {
      this.entry_id = entry_id
      axios.get(`/api/admissions/family_score/rectory/${entry_id}`)
        .then(resp => {
          if (resp.status === 200) {
            this.score = resp.data
            this.score_dialog = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    countryName (value) {
      if (value) {
        return this.countries.filter(country => country.value == value)[0].text
      }
    },
    stateName (value, country) {
      if (value && country) {
        return this.states.filter(state => state.value == value && state.id_pais == country)[0].text
      }
    },
    cityName (value, state) {
      if (value && state) {
        return this.cities.filter(city => city.value == value && city.id_departamento == state)[0].text
      }
    },
    handleRectoryStatus(rectory_id, status) {
      axios.put('/api/admissions/rectory/change_status', { id: rectory_id, continua: !status })
        .then(resp => {
          if (resp.status === 200) {
            this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Estado actualizado',
              modal: false
            })
            this.getEntry()
          }
        })
    },
    showAssigned() {
      this.assigned = this.entries_to_show.filter(entry => entry.rectory_status === 1 && !entry.rectory_notification)
      this.assigned_dialog = true
    },
    async sendAssigned() {
      const result = await axios.get('/api/admissions/send_assigned')

      if (result.status === 200) {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: 'Notificaciones Enviadas',
          modal: false
        })
        this.assigned_dialog = false
        this.getEntry()
      }
    },
    showNotAssigned() {
      this.not_assigned = this.entries_to_show.filter(entry => entry.rectory_status === 0 && !entry.rectory_notification)
      this.not_assigned_dialog = true
    },
    async sendNotAssigned() {
      const result = await axios.get('/api/admissions/send_not_assigned')

      if (result.status === 200) {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: 'Notificaciones Enviadas',
          modal: false
        })
        this.not_assigned_dialog = false
        this.getEntry()
      }
    }
  }
}
</script>
<style>
.center {
  text-align: center;
  vertical-align: middle;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.editable_image {
  display: flex;
  justify-content: space-between;
}
.sticky {  
  position: sticky;
  top: 0;
}
table.v-table thead td:not(:nth-child(1)), table.v-table tbody td:not(:nth-child(1)), table.v-table thead th:not(:nth-child(1)), table.v-table tbody th:not(:nth-child(1)), table.v-table thead td:first-child, table.v-table tbody td:first-child, table.v-table thead th:first-child, table.v-table tbody th:first-child {
  padding: 0 16px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/manage/entries_rectory.vue